import { render, staticRenderFns } from "./ProductFeature.pug?vue&type=template&id=00fae60e&scoped=true&lang=pug&"
import script from "./ProductFeature.js?vue&type=script&lang=js&"
export * from "./ProductFeature.js?vue&type=script&lang=js&"
import style0 from "./ProductFeature.sass?vue&type=style&index=0&id=00fae60e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fae60e",
  null
  
)

component.options.__file = "ProductFeature.vue"
export default component.exports